import getAllColumnsSettings from './columns-settings';
import getThisColumnSettings from './column-settings';

export default {
  getAllColumnsSettings,
  getThisColumnSettings,
};
